import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import AppContainer from "./AppContainer";
import App from "./App";
import { createAzureAppIPlugin } from "./utils/azureAppI";
import { setAppInsights } from "./utils/appInsightsInstance";
import { Config } from "core/models";
import "ui/styling/global.scss";

const getConfig = async (): Promise<Config> =>
    new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        request.open("GET", "/config.json", true);
        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                const data = JSON.parse(request.responseText);
                resolve(data);
            } else {
                reject();
            }
        };
        request.send();
    });

function renderApp(): void {
    getConfig()
        .then((config) => {
            if (import.meta.env.VITE_baseURL) {
                window.jsonConfig = {
                    apiUrl: import.meta.env.VITE_apiURL,
                    authApiURL: import.meta.env.VITE_authApiURL,
                    siteApiURL: import.meta.env.VITE_siteApiURL,
                    fileApiURL: import.meta.env.VITE_fileApiURL,
                    verifyURL: import.meta.env.VITE_verifyURL,
                    passwordURL: import.meta.env.VITE_passwordURL,
                    activateURL: import.meta.env.VITE_activateURL,
                    oauthURL: import.meta.env.VITE_oauthURL,
                    baseURL: import.meta.env.VITE_baseURL,
                    storagePrefix: import.meta.env.VITE_storagePrefix,
                    theoLicenseKey: import.meta.env.VITE_theoLicenseKey,
                    azureAppIConnectionString: import.meta.env
                        .VITE_azureAppIConnectionString,
                };
            } else {
                window.jsonConfig = config;
            }
            let environment = "Development";
            if (config.baseURL === "https://v2-acc.spot-on.media/") {
                environment = "Acceptance";
            }
            if (config.baseURL === "https://app.spot-on.media/") {
                environment = "Production";
            }

            if (process.env.NODE_ENV === "production") {
                Sentry.init({
                    dsn: "https://3e877bdec205417d9fbeafcb25569b43@sentry.wearetriple.com/46",
                    integrations: [Sentry.browserTracingIntegration],
                    tracesSampleRate: 0.5,
                    environment,
                });
            }

            const { azureAppIPlugin, appInsights: aiInstance } =
                createAzureAppIPlugin();
            setAppInsights(aiInstance);

            const root = ReactDOM.createRoot(
                document.getElementById("root") as HTMLElement,
            );
            root.render(
                <React.StrictMode>
                    <AppInsightsContext.Provider value={azureAppIPlugin}>
                        <AppContainer>
                            <App />
                        </AppContainer>
                    </AppInsightsContext.Provider>
                </React.StrictMode>,
            );
        })
        .catch((err) => console.error(err));
}

renderApp();
